import React from 'react';
import * as styles from '../styles/SweetAlertStyles';

var ErrorIcon = function ErrorIcon() {
  return React.createElement("div", {
    style: Object.assign({}, styles.icon, styles.iconError)
  }, React.createElement("span", {
    style: styles.iconErrorX
  }, React.createElement("span", {
    style: Object.assign({}, styles.iconErrorLine, styles.iconErrorLineLeft)
  }), React.createElement("span", {
    style: Object.assign({}, styles.iconErrorLine, styles.iconErrorLineRight)
  })));
};

export default ErrorIcon;